import { render, staticRenderFns } from "./menuGroupManage.vue?vue&type=template&id=749a2df7&scoped=true"
import script from "./menuGroupManage.vue?vue&type=script&lang=js"
export * from "./menuGroupManage.vue?vue&type=script&lang=js"
import style0 from "./menuGroupManage.vue?vue&type=style&index=0&id=749a2df7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749a2df7",
  null
  
)

export default component.exports